/// <reference path='../../modules/app.module.ts'/>
/// <reference path="../../controllers/shell.controller.ts" />

module App {
    var getRoutes = (): App.Interfaces.ICustomState[] => {
        var route: App.Interfaces.ICustomState = {
            name: Constants.routeKeys.contact,
            url: '/' + 'contact',
            cache: false,
            title: 'Uw gegevens',
            headerTitle: 'Uw gegevens',
            configuratorStepName: ['PostalCodeStep'],
            order: 5,
            operations: ['SetContact'],
            views: {
                [Constants.viewRegions.appContent]: {
                    templateUrl: '/templates/contact.html',
                    controller: Controllers.ContactController.controllerId + ' as vm'
                }
            },
            showInMenu: true
        }

        return [route];
    }

    function appRun(routehelper: Blocks.Interfaces.IRouterFactory) {
        routehelper.configureRoutes(getRoutes());
    }

    App.Core.appCore.run(appRun);
}